import { createRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { ApiError } from "../../shared/api/http.js";
import { Button, Card, Field, Input } from "../../shared/ui/index.js";
import { CenteredLayout } from "../../shared/ui/CenteredLayout.js";
import { useAcceptInvite } from "./auth.api.js";
import { rootRoute } from "../../app/root-route.js";

export const invitationRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/invitation",
  validateSearch: (s: Record<string, unknown>): { token?: string } => ({
    token: typeof s.token === "string" ? s.token : undefined,
  }),
  component: InvitationScreen,
});

function InvitationScreen() {
  const { token } = invitationRoute.useSearch();
  const navigate = useNavigate();
  const accept = useAcceptInvite();
  const [password, setPassword] = useState("");

  if (!token) {
    return (
      <CenteredLayout>
        <Card>
          <p className="text-sm text-stone-600">Lien d'invitation invalide.</p>
        </Card>
      </CenteredLayout>
    );
  }

  return (
    <CenteredLayout>
      <Card>
        <h1 className="font-serif text-xl text-stone-900">Bienvenue sur SmartVow</h1>
        <p className="mt-1 text-sm text-stone-500">Choisissez votre mot de passe.</p>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            accept.mutate(
              { token, password },
              { onSuccess: () => navigate({ to: "/app" }) },
            );
          }}
          className="mt-4 flex flex-col gap-3"
        >
          <Field label="Mot de passe (8 caractères min.)">
            <Input
              type="password"
              required
              minLength={8}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Field>
          {accept.error && (
            <p className="text-sm text-rose-600">
              {accept.error instanceof ApiError ? accept.error.message : "Erreur"}
            </p>
          )}
          <Button type="submit" disabled={accept.isPending}>
            Activer mon compte
          </Button>
        </form>
      </Card>
    </CenteredLayout>
  );
}
